/*
 * SolutionsDropdown Messages
 *
 * This contains all the text for the Header "Giải pháp" hover dropdown.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.MainNav.SolutionsDropdown';

export default defineMessages({
  sectionBusinessTypes: {
    id: `${scope}.sectionBusinessTypes`,
    defaultMessage: 'Loại hình doanh nghiệp',
  },
  sectionFeaturedProducts: {
    id: `${scope}.sectionFeaturedProducts`,
    defaultMessage: 'Sản phẩm nổi bật',
  },
  restaurantTitle: {
    id: `${scope}.restaurantTitle`,
    defaultMessage: 'Nhà hàng',
  },
  restaurantDescription: {
    id: `${scope}.restaurantDescription`,
    defaultMessage: 'Nguyên liệu tươi sống, gia vị cao cấp, đáp ứng mọi phân khúc bếp.',
  },
  coffeeBakeryTitle: {
    id: `${scope}.coffeeBakeryTitle`,
    defaultMessage: 'Cà phê, Tiệm bánh',
  },
  coffeeBakeryDescription: {
    id: `${scope}.coffeeBakeryDescription`,
    defaultMessage: 'Đầy đủ hạt cà phê, sữa tươi, syrup và nguyên liệu pha chế giá tốt.',
  },
  eateryTitle: {
    id: `${scope}.eateryTitle`,
    defaultMessage: 'Quán ăn, bếp online',
  },
  eateryDescription: {
    id: `${scope}.eateryDescription`,
    defaultMessage: 'Món ăn chế biến sẵn, rau củ tươi và combo tiện lợi.',
  },
  barPubTitle: {
    id: `${scope}.barPubTitle`,
    defaultMessage: 'Bar, Pub',
  },
  barPubDescription: {
    id: `${scope}.barPubDescription`,
    defaultMessage: 'Cung cấp đồ uống, nguyên liệu cocktail và trái cây decor quầy bar.',
  },
  hotelTitle: {
    id: `${scope}.hotelTitle`,
    defaultMessage: 'Khách sạn',
  },
  hotelDescription: {
    id: `${scope}.hotelDescription`,
    defaultMessage: 'Giải pháp trọn gói cho buffet, nhà hàng nội khu và nhu yếu phẩm.',
  },
  storeTitle: {
    id: `${scope}.storeTitle`,
    defaultMessage: 'Siêu thị, Cửa hàng',
  },
  storeDescription: {
    id: `${scope}.storeDescription`,
    defaultMessage: 'Nguồn hàng sỉ số lượng lớn, ổn định với chiết khấu thương mại cao.',
  },
  officeTitle: {
    id: `${scope}.officeTitle`,
    defaultMessage: 'Văn phòng, Căn tin',
  },
  officeDescription: {
    id: `${scope}.officeDescription`,
    defaultMessage: 'Cung ứng pantry, bữa ăn tiện lợi, đầy đủ hóa đơn và chứng từ pháp lý.',
  },
  schoolFactoryTitle: {
    id: `${scope}.schoolFactoryTitle`,
    defaultMessage: 'Trường học, Nhà máy',
  },
  schoolFactoryDescription: {
    id: `${scope}.schoolFactoryDescription`,
    defaultMessage: 'Nguồn thực phẩm chuẩn ATVSTP, sản lượng lớn và bình ổn giá thành.',
  },
  productFarmToBusinessTitle: {
    id: `${scope}.productFarmToBusinessTitle`,
    defaultMessage: 'Tươi từ nông trại',
  },
  productFarmToBusinessDescription: {
    id: `${scope}.productFarmToBusinessDescription`,
    defaultMessage: 'Rau củ quả tươi từ nông trại Đà Lạt.',
  },
  productKamereoNgonTitle: {
    id: `${scope}.productKamereoNgonTitle`,
    defaultMessage: 'Kamereo Ngon',
  },
  productKamereoNgonDescription: {
    id: `${scope}.productKamereoNgonDescription`,
    defaultMessage: 'Thực phẩm tươi sạch thương hiệu Kamereo.',
  },
  productKamereoTienDungTitle: {
    id: `${scope}.productKamereoTienDungTitle`,
    defaultMessage: 'Kamereo Tiện Dụng',
  },
  productKamereoTienDungDescription: {
    id: `${scope}.productKamereoTienDungDescription`,
    defaultMessage: 'Vật dụng thiết yếu thương hiệu Kamereo.',
  },
});
